import React from 'react';
import { Button, Checkbox } from '@material-ui/core';
import Spinner from '../UI/Spinner/spinner';
import css from  '../Transaction/transaction.css';

const renderRows = (rows, selected, handleClicked) => {
    return rows.map(row => {
        return (
        <tr key={row.BankDataGUID}>
            <td><Checkbox id={row.BankDataGUID} onChange={() => handleClicked(row.BankDataGUID)} checked={selected && selected.includes(row.BankDataGUID)} /></td>
            <td>{row.TransactionDate}</td>
            <td>{row.Description}</td>
            <td>{(row.Amount && row.Amount < 0) ? (row.Amount*-1).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : ''}</td>
            <td>{(row.Amount && row.Amount >= 0) ? row.Amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') : ''}</td>
        </tr>);
    });
};

const RemoveTransactionTable = ({ transactions, selected, handleClicked, closeRemoveModal, handleRemoveClicked, selectAllCheckboxClicked }) => {
    const transactionList = transactions.filter(item => item.manualUpload && (item.Coding.length === 0 || (item.Coding[0] && item.Coding[0].CodingType === "Rule")));

    return (
        <div className={[css.width1000, css.center].join(' ')}>
            <div className={css.flexSpace}>
                <div>Remove Transactions</div>
                <div>
                    {selected.length > 0 && <Button type="button" variant="contained" size="small" color="secondary" onClick={handleRemoveClicked}>Remove Selected</Button>}&nbsp;&nbsp;
                    <Button type="button" variant="contained" size="small" onClick={closeRemoveModal}>Cancel</Button>&nbsp;&nbsp;
                </div>
            </div>
            <table cellSpacing='0' cellPadding='0' className={[css.center, css.table, css.tableBordered, css.tableStriped, css.removeTable].join(' ')}>
                <thead>
                    <tr>
                        <th width="50"><Checkbox onChange={() => selectAllCheckboxClicked(transactionList)} checked={transactionList.length===selected.length} /></th>
                        <th width="100">Date</th>
                        <th>Description</th>
                        <th width="120">Money out</th>
                        <th width="120">Money in</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions ? renderRows(transactionList, selected, handleClicked) : <tr><td colSpan="7"><Spinner /></td></tr>}
                </tbody>
            </table>
        </div>
    );
}

export default RemoveTransactionTable;


// WEBPACK FOOTER //
// ./src/components/TransactionList/RemoveTransactionTable.js